export const instagram = {
	GET_IG_PROFILE: "instagram/get",
	CHANGE_IG_PROFILE: "instagram/change",
}

export default instagram
